import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  loading$ = this._loading.asObservable();

  show() {
    this._loading.next(true);
  }

  hide(initializing?: boolean) {
    if (initializing) {
      timer(2100).subscribe(() => {
          this._loading.next(false);
      });
    } else {
      this._loading.next(false);
    }
  }
}